<template>
  <label :for="props.for">
    <div class="label-container">
      <span class="label-left">
        <strong>
          {{ props.label }}
          <span
            class="required"
            v-if="props.required"
          >
            *
          </span>
        </strong>
        <slot name="label-hint" />
      </span>
      <Tooltip v-if="props.helperText">
        <span class="helper-icon material-symbols-outlined">help</span>
        <template #popper>
          <div class="helper">
            {{ props.helperText }}
          </div>
        </template>
      </Tooltip>
    </div>
    <span
      class="sub-label"
      v-if="props.subLabel"
    >
      {{ props.subLabel }}
    </span>
  </label>
</template>
<script lang="ts" setup>
import { Tooltip } from 'floating-vue';

export type LabelProps = {
  for: string;
  label: string;
  helperText?: string;
  required?: boolean;
  subLabel?: string;
};

const props = defineProps<LabelProps>();
</script>
<style lang="scss" scoped>
.label-container {
  display: grid;
  grid-template-columns: 2fr auto;
  align-items: center;
  column-gap: $spacing-3xs;

  .label-left {
    display: flex;
    align-items: center;
    gap: $spacing-xs;
    @media (max-width: $breakpoint-sm) {
      flex-direction: column;
      align-items: flex-start;
      gap: $spacing-4xs;
    }
  }
}
.required {
  color: $brand-blue;
}
.helper-icon {
  color: $brand-blue;
  cursor: pointer;
}
.v-popper--theme-tooltip {
  height: 24px;
}
.sub-label {
  font-size: $font-size-xs;
  color: $gray-68;
}
</style>
